import { render, staticRenderFns } from "./UserButton.vue?vue&type=template&id=3a7ae7ea&scoped=true&"
import script from "./UserButton.vue?vue&type=script&lang=js&"
export * from "./UserButton.vue?vue&type=script&lang=js&"
import style0 from "./UserButton.vue?vue&type=style&index=0&id=3a7ae7ea&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a7ae7ea",
  null
  
)

export default component.exports